(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ponytail: temporary launch code auto-apply, delete after 27.09.2026.
    // Puts the launch code into the cart once per browser, only if no other code
    // (e.g. a partner code) is there. Removing it in checkout sticks.
    function applyLaunchCode(code) {
      var key = 'vamoya-launch-code-' + code;
      try {
        if (window.localStorage.getItem(key) === '1') return;
      } catch (e) {}
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) { return d.code.toUpperCase(); });
          var others = codes.filter(function (c) { return c.indexOf('LAUNCH') !== 0; });
          if (others.length) return;
          // Only remember once the code sits on a cart with items; an empty cart may drop it.
          var done = function () {
            if (cart.item_count > 0) try { window.localStorage.setItem(key, '1'); } catch (e) {}
          };
          if (codes.indexOf(code) !== -1) return done();
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(function () {
            done();
            // Re-render the drawer so the code shows (no loop: next run finds the code).
            if (cart.item_count > 0) document.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        })
        .catch(function () {});
    }

    function initAnnouncement(bar) {
      if (bar.dataset.announcementReady === 'true') return;
      bar.dataset.announcementReady = 'true';

      var dismissKey = bar.getAttribute('data-dismissible');
      if (dismissKey) {
        try {
          if (window.sessionStorage.getItem(dismissKey) === '1') {
            bar.hidden = true;
            return;
          }
        } catch (e) {}

        var closeBtn = bar.querySelector('[data-announcement-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            bar.hidden = true;
            try {
              window.sessionStorage.setItem(dismissKey, '1');
            } catch (e) {}
          });
        }
      }

      // ponytail: temporary launch message, delete after 27.09.2026
      var launch = bar.querySelector('[data-launch-message]');
      if (launch) {
        var now = Date.now();
        if (now < Date.UTC(2026, 8, 27, 22)) {
          var isTen = now < Date.UTC(2026, 8, 26, 12);
          launch.querySelector('.announcement__text').textContent = launch.getAttribute(isTen ? 'data-text-10' : 'data-text-5');
          var launchCode = isTen ? 'LAUNCH10' : 'LAUNCH5';
          applyLaunchCode(launchCode);
          document.addEventListener('cart:refresh', function () { applyLaunchCode(launchCode); });
          bar.querySelectorAll('.announcement__message').forEach(function (m) {
            m.hidden = m !== launch;
          });
        } else {
          launch.remove();
        }
      }

      var messages = bar.querySelectorAll('.announcement__message');
      var speed = parseInt(bar.getAttribute('data-rotate'), 10);
      if (messages.length > 1 && speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var current = 0;
        setInterval(function () {
          if (document.hidden || bar.matches(':hover') || bar.contains(document.activeElement)) return;
          messages[current].hidden = true;
          current = (current + 1) % messages.length;
          messages[current].hidden = false;
        }, speed * 1000);
      }
    }

    function run() {
      document.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.drawerReady === 'true') return;
    drawer.dataset.drawerReady = 'true';

    var sectionId = drawer.closest('.shopify-section')
      ? drawer.closest('.shopify-section').id.replace('shopify-section-', '')
      : 'cart-drawer';
    var lastFocus = null;
    var closeTimer;
    var changing = false;
    var refreshId = 0;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var errorEl = drawer.querySelector('[data-cart-error]');

    function panel() {
      return drawer.querySelector('.cart-drawer__panel');
    }

    function open(trigger) {
      window.clearTimeout(closeTimer);
      if (!drawer.classList.contains('is-open')) lastFocus = trigger || document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('[data-cart-close].icon-btn');
      if (window.VamoyaFocus) window.VamoyaFocus.focusQuietly(closeBtn || panel());
      else if (closeBtn) closeBtn.focus();
      else if (panel()) panel().focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(function () {
        drawer.hidden = true;
        if (window.VamoyaFocus) window.VamoyaFocus.focusQuietly(lastFocus);
        else if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }, 420);
    }

    function setBusy(busy) {
      var content = drawer.querySelector('[data-cart-drawer-content]');
      content.setAttribute('aria-busy', String(busy));
      content.querySelectorAll('[data-qty] button, [data-qty] input, [data-cart-remove], [name="checkout"]').forEach(function (el) {
        el.disabled = busy;
      });
    }

    function showError() {
      errorEl.hidden = false;
    }

    function refresh(thenOpen, focusElement) {
      var requestId = ++refreshId;
      return fetch(root + '?sections=' + encodeURIComponent(sectionId))
        .then(function (response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        })
        .then(function (data) {
          if (requestId !== refreshId) return;
          var html = data[sectionId];
          if (!html) throw new Error('cart');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var current = drawer.querySelector('[data-cart-drawer-content]');
          if (!fresh || !current) throw new Error('cart');
          var active = focusElement || document.activeElement;
          var restore = current.contains(active);
          var qty = restore && active.closest('[data-qty]');
          var line = qty && qty.dataset.line;
          current.replaceWith(fresh);
          setBusy(changing);
          updateHeaderCount(drawer);
          if (thenOpen) open();
          else if (restore) {
            var target = line && fresh.querySelector('[data-qty][data-line="' + line + '"] .qty__input');
            // Restore after busy controls are re-enabled by the change handler.
            window.setTimeout(function () {
              var focus = target || fresh.querySelector('[data-cart-close]');
              if (focus && !drawer.hidden) focus.focus();
            }, 0);
          }
        });
    }

    function updateHeaderCount(doc) {
      var freshCount = doc.querySelector('.cart-drawer__count');
      var badge = document.querySelector('[data-cart-count]');
      if (!badge || !freshCount) return;
      var count = parseInt(freshCount.textContent.replace(/[^0-9]/g, ''), 10) || 0;
      badge.textContent = count;
      badge.hidden = count === 0;
    }

    function changeLine(line, quantity) {
      if (changing || !Number.isInteger(quantity) || quantity < 0) return;
      var focusElement = document.activeElement;
      changing = true;
      errorEl.hidden = true;
      setBusy(true);
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart');
        return refresh(false, focusElement);
      }).catch(function () {
        showError();
        // A rejected quantity can still alter stock-limited cart quantities.
        return refresh(false, focusElement).catch(showError);
      }).finally(function () {
        changing = false;
        setBusy(false);
      });
    }

    document.addEventListener('cart:refresh', function (event) {
      var thenOpen = Boolean(event.detail && event.detail.open);
      errorEl.hidden = true;
      refresh(thenOpen).catch(function () {
        showError();
        if (thenOpen) open();
      });
    });

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-cart-open]');
      if (openBtn) {
        event.preventDefault();
        open(openBtn);
        return;
      }
      if (event.target.closest('[data-cart-close]') && event.target.closest('[data-cart-drawer]')) {
        close();
        return;
      }
      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        changeLine(parseInt(removeBtn.dataset.line, 10), 0);
      }
    });

    document.addEventListener('change', function (event) {
      var qty = event.target.closest('[data-qty]');
      if (!qty || !drawer.contains(qty) || !qty.dataset.line) return;
      var input = qty.querySelector('.qty__input');
      if (!input.reportValidity() || input.value.trim() === '') return;
      changeLine(parseInt(qty.dataset.line, 10), Number(input.value));
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (window.VamoyaFocus) window.VamoyaFocus.trap(event, panel());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
        if (select.dataset.sortReady === 'true') return;
        select.dataset.sortReady = 'true';
        select.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initGrid(grid) {
      if (grid.dataset.photoReady) return;
      grid.dataset.photoReady = 'true';
      const dialog = grid.querySelector('[data-color-photo-dialog]');
      const content = dialog.querySelector('[data-color-dialog-content]');
      grid.addEventListener('error', (event) => {
        if (!event.target.matches('.colorgrid__hover-image, .colorgrid__product-image')) return;
        event.target.hidden = true;
        const label = event.target.closest('.colorgrid__card-image')?.querySelector('.colorgrid__example');
        if (label) {
          label.hidden = false;
          label.textContent = grid.dataset.colorMissing;
        }
      }, true);
      grid.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-color-photo-open]');
        if (opener) {
          const template = opener.closest('.colorgrid__item').querySelector('template');
          content.replaceChildren(template.content.cloneNode(true));
          dialog.setAttribute('aria-labelledby', content.querySelector('h3').id);
          dialog.showModal();
          return;
        }
        if (event.target.closest('[data-color-photo-close]') || event.target === dialog) dialog.close();
      });
    }
    const run = () => document.querySelectorAll('.colorgrid').forEach(initGrid);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HEADING_OFFSET = 120;

    /*
      Germans reach the same word three ways: "Größe", "groesse", "grosse".
      Fold to both the digraph form (ö -> oe) and the stripped form (ö -> o),
      then search the pair — so any of the three spellings hits.
    */
    function foldDigraph(value) {
      return (value || '')
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function foldStripped(value) {
      return (value || '')
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function haystack(value) {
      return foldDigraph(value) + ' \u0000 ' + foldStripped(value);
    }

    function initFaq(root) {
      if (!root || root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
      var categories = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
      var status = root.querySelector('[data-faq-status]');
      var empty = root.querySelector('[data-faq-empty]');
      var nav = root.querySelector('[data-faq-nav]');
      var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav-link]'));
      var searchWrap = root.querySelector('[data-faq-search]');
      var input = root.querySelector('[data-faq-input]');
      var clear = root.querySelector('[data-faq-clear]');

      items.forEach(function (item) {
        item.dataset.faqHaystack = haystack(item.dataset.faqText);
      });

      /* Each category owns the items that follow it until the next category. */
      var groups = [];
      var current = null;
      Array.prototype.slice.call(root.querySelectorAll('[data-faq-category], [data-faq-item]')).forEach(function (node) {
        if (node.hasAttribute('data-faq-category')) {
          current = { heading: node, items: [] };
          groups.push(current);
        } else if (current) {
          current.items.push(node);
        }
      });

      function setActive(id) {
        navLinks.forEach(function (link) {
          if (link.dataset.faqNavLink === id) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      function filter(rawQuery) {
        var digraph = foldDigraph(rawQuery).trim();
        var stripped = foldStripped(rawQuery).trim();
        var active = digraph.length > 1;
        var matches = 0;

        items.forEach(function (item) {
          var hay = item.dataset.faqHaystack;
          var hit = !active || hay.indexOf(digraph) !== -1 || hay.indexOf(stripped) !== -1;
          item.hidden = !hit;
          var details = item.querySelector('details');
          if (details) details.open = hit && active;
          if (hit) matches += 1;
        });

        groups.forEach(function (group) {
          group.heading.hidden =
            active &&
            !group.items.some(function (item) {
              return !item.hidden;
            });
        });

        if (nav) nav.hidden = active;
        if (empty) empty.hidden = !active || matches > 0;
        if (clear) clear.hidden = rawQuery.length === 0;

        /* At zero matches the empty state already says it — don't say it twice. */
        if (status) {
          status.hidden = !active || matches === 0;
          status.textContent =
            active && matches > 0
              ? matches === 1
                ? status.dataset.resultsOne
                : status.dataset.resultsOther.replace('%COUNT%', matches)
              : '';
        }
      }

      if (searchWrap && input) {
        searchWrap.hidden = false;
        input.addEventListener('input', function () {
          filter(input.value);
        });
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && input.value) {
            event.preventDefault();
            input.value = '';
            filter('');
          }
        });
      }

      if (clear && input) {
        clear.addEventListener('click', function () {
          input.value = '';
          filter('');
          input.focus();
        });
      }

      navLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.getElementById(link.dataset.faqNavLink);
          if (!target) return;
          event.preventDefault();
          setActive(link.dataset.faqNavLink);
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          if (history.replaceState) history.replaceState(null, '', '#' + link.dataset.faqNavLink);
        });
      });

      /* Scroll spy: the last heading that has passed under the header wins. */
      if (categories.length && navLinks.length) {
        var ticking = false;
        var sync = function () {
          ticking = false;
          var activeId = categories[0].id;
          categories.forEach(function (heading) {
            if (!heading.hidden && heading.getBoundingClientRect().top <= HEADING_OFFSET) {
              activeId = heading.id;
            }
          });
          setActive(activeId);
        };
        window.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(sync);
          },
          { passive: true }
        );
        sync();
      }
    }

    function initAll(scope) {
      Array.prototype.slice.call((scope || document).querySelectorAll('[data-faq]')).forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function run() {
      document.querySelectorAll('[data-country-select]').forEach(function (select) {
        if (select.dataset.ready === 'true') return;
        select.dataset.ready = 'true';
        select.addEventListener('change', function () {
          if (select.form) select.form.submit();
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeader(header) {
      if (!header || header.dataset.headerReady === 'true') return;
      header.dataset.headerReady = 'true';

      var toggle = header.querySelector('[data-nav-toggle]');
      var panel = header.querySelector('[data-nav-panel]');

      var lastY = window.scrollY;
      var hideTicking = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function setScrolled() {
        // Hysteresis: shrink at 48px but only grow back near the very top,
        // so the 16px height change never re-triggers on momentum bounce.
        var scrolled = header.classList.contains('is-scrolled');
        if (scrolled && window.scrollY < 8) {
          header.classList.remove('is-scrolled');
        } else if (!scrolled && window.scrollY > 48) {
          header.classList.add('is-scrolled');
        }
      }

      function setHiddenOnScroll() {
        hideTicking = false;
        var y = window.scrollY;
        var delta = y - lastY;
        setScrolled();

        if (reduceMotion.matches || header.classList.contains('is-nav-open') || header.contains(document.activeElement)) {
          header.classList.remove('is-hidden');
          lastY = y;
          return;
        }

        // Stay visible near the top; hide only once the visitor is clearly
        // moving down the page, and bring it back on any upward travel.
        if (y < 64) {
          header.classList.remove('is-hidden');
        } else if (delta > 8) {
          header.classList.add('is-hidden');
        } else if (delta < -8) {
          header.classList.remove('is-hidden');
        }
        lastY = y;
      }

      function onScroll() {
        if (hideTicking) return;
        hideTicking = true;
        window.requestAnimationFrame(setHiddenOnScroll);
      }

      header.addEventListener('focusin', function () { header.classList.remove('is-hidden'); });
      setScrolled();
      window.addEventListener('scroll', onScroll, { passive: true });

      if (toggle && panel) {
        var closeTimer = null;
        var finishClose = null;
        var sliding = panel.querySelector('.header__drawer-panel');

        function setNavOpen(open) {
          window.clearTimeout(closeTimer);
          if (sliding && finishClose) sliding.removeEventListener('transitionend', finishClose);
          finishClose = null;
          toggle.setAttribute('aria-expanded', String(open));
          document.documentElement.style.overflow = open ? 'hidden' : '';

          if (open) {
            header.classList.remove('is-hidden');
            panel.hidden = false;
            // Unhide first, then force a reflow, so the panel animates in from
            // off-screen instead of appearing already open.
            void panel.offsetWidth;
            header.classList.add('is-nav-open');
            // The panel itself, not the first link: focusing a link paints a
            // ring around it the moment the drawer opens.
            var target = sliding || panel;
            if (window.VamoyaFocus) window.VamoyaFocus.focusQuietly(target);
            else if (target.focus) target.focus();
            return;
          }

          header.classList.remove('is-nav-open');
          if (window.VamoyaFocus) window.VamoyaFocus.focusQuietly(toggle);
          else toggle.focus();
          // Keep it in the DOM until the slide-out has played. The timeout is
          // the fallback for reduced motion, where transitionend never fires.
          var done = false;
          function finish() {
            if (done) return;
            done = true;
            panel.hidden = true;
          }
          finishClose = finish;
          if (sliding) sliding.addEventListener('transitionend', finish, { once: true });
          closeTimer = window.setTimeout(finish, 600);
        }

        toggle.addEventListener('click', function () {
          setNavOpen(!header.classList.contains('is-nav-open'));
        });

        panel.addEventListener('click', function (event) {
          if (event.target.closest('a') || event.target.closest('[data-nav-close]')) {
            setNavOpen(false);
          }
        });

        document.addEventListener('keydown', function (event) {
          if (!header.classList.contains('is-nav-open')) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            setNavOpen(false);
            return;
          }
          if (window.VamoyaFocus) window.VamoyaFocus.trap(event, sliding || panel);
        });
      }

    }

    function run() {
      document.querySelectorAll('[data-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-options"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vamoya-hero')) {
    customElements.define('vamoya-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const updateTop = () => {
          const sections = document.querySelectorAll('.shopify-section-group-header-group');
          const height = Array.from(sections).reduce((sum, section) => sum + section.offsetHeight, 0);
          this.style.setProperty('--hero-top', `${height || 112}px`);
        };
        this.observer = new ResizeObserver(updateTop);
        document.querySelectorAll('.shopify-section-group-header-group').forEach(el => this.observer.observe(el));
        updateTop();
        const video = this.querySelector('video');
        if (!video) return;
        const button = this.querySelector('.hero-options__play');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let userPaused = false;
        const syncButton = () => {
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
        };
        const play = () => {
          const source = video.querySelector('source[data-src]');
          if (source) { source.src = source.dataset.src; delete source.dataset.src; video.load(); }
          video.muted = true;
          video.play().catch(syncButton);
        };
        video.addEventListener('play', syncButton, options);
        video.addEventListener('pause', syncButton, options);
        video.addEventListener('error', () => { button.hidden = true; }, options);
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) { userPaused = false; play(); }
          else { userPaused = true; video.pause(); }
        }, options);
        motion.addEventListener('change', () => {
          if (motion.matches) video.pause();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) video.pause();
          else if (!userPaused && !motion.matches && !navigator.connection?.saveData) play();
        }, options);
        if (!motion.matches && !navigator.connection?.saveData) play();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (!root || root.dataset.productReady === 'true') return;
      root.dataset.productReady = 'true';

      var section = root.closest('.shopify-section') || document;
      var dataEl = section.querySelector('[data-variant-data]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var pricesEl = section.querySelector('[data-variant-prices]');
      var prices = pricesEl ? JSON.parse(pricesEl.textContent) : {};
      var galleryOptionIndex = parseInt(root.dataset.galleryOptionIndex, 10);
      var hardwareOptionIndex = parseInt(root.dataset.hardwareOptionIndex, 10);
      var form = root.querySelector('[data-product-form], form[action*="/cart/add"]');
      var idInput = root.querySelector('[data-variant-id]');
      var atc = root.querySelector('[data-add-to-cart]');
      var errorEl = root.querySelector('[data-form-error]');
      var priceWrap = root.querySelector('[data-price-wrap] .price');
      var picker = root.querySelector('[data-variant-picker]');
      var adding = false;
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sizeOptionIndex = parseInt(root.dataset.sizeOptionIndex, 10);
      var colorOptionIndex = parseInt(root.dataset.colorOptionIndex, 10);
      var duplicateCheck = section.querySelector('[data-duplicate-check]');
      var CANCELLED = {};

      // Resolves false when the visitor decides not to add this variant next
      // to one already in the cart in the same size (other colour or fitting)
      // or the same colour (other size): the "order two, return one" pattern.
      // Other size AND other colour usually means a second horse, so it
      // passes unasked. A failed cart read never blocks the purchase.
      function confirmDuplicate(variant) {
        if (!duplicateCheck || !variant) return Promise.resolve(true);
        function same(other, index) {
          return index < 0 || other.options[index] === variant.options[index];
        }
        return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            // More of a variant already in the cart is a quantity change, not a new pick.
            if (cart.items.some(function (item) { return item.variant_id === variant.id; })) return true;
            var twins = cart.items
              .map(function (item) {
                return variants.find(function (v) { return v.id === item.variant_id; });
              })
              .filter(function (other) {
                return other && (same(other, sizeOptionIndex) || same(other, colorOptionIndex));
              });
            if (!twins.length) return true;
            duplicateCheck.querySelector('[data-duplicate-list]').textContent = twins
              .map(function (other) { return other.title; })
              .join(', ');
            // Escape keeps the previous value, so a stale "add" must not survive.
            duplicateCheck.returnValue = '';
            duplicateCheck.showModal();
            return new Promise(function (resolve) {
              duplicateCheck.addEventListener('close', function () {
                resolve(duplicateCheck.returnValue === 'add');
              }, { once: true });
            });
          })
          .catch(function () {
            return true;
          });
      }

      function selectedOptions() {
        var values = [];
        if (!picker) return values;
        picker.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('[data-option-input]:checked');
          values[parseInt(fieldset.dataset.optionIndex, 10)] = checked ? checked.value : null;
        });
        return values;
      }

      function findVariant(values) {
        if (!picker) return variants.find(function (variant) { return String(variant.id) === idInput.value; });
        return variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return opt === values[i];
          });
        });
      }

      function updatePrice(variant) {
        if (!priceWrap || !variant) return;
        var money = prices[variant.id];
        var html = '<span class="price__current">' + money.price + '</span>';
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (sale) html += ' <s class="price__compare">' + money.compare_at_price + '</s>';
        priceWrap.classList.toggle('price--sale', Boolean(sale));
        priceWrap.innerHTML = html;

        var wrapEl = root.querySelector('[data-price-wrap]');
        var savingsEl = root.querySelector('[data-savings]');
        if (wrapEl && savingsEl) {
          if (sale) {
            var tpl = wrapEl.dataset.savingsTemplate || '[AMOUNT]';
            savingsEl.textContent = tpl.replace('[AMOUNT]', money.saved);
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }
        var stickyPrice = section.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money.price;
      }

      // True when the current selection includes an option value the shop
      // has flagged as not currently produced (custom.unavailable_options).
      // Kept separate from variant.available: those variants exist and may
      // even read as in stock, but we are not making them at the moment.
      function selectionInWorkshop() {
        if (!picker) return false;
        return picker.querySelector('[data-option-input][data-workshop]:checked') !== null;
      }

      function updateButton(variant) {
        if (!atc) return;
        var inWorkshop = selectionInWorkshop();
        var unchosen = picker && picker.querySelector('[data-option-index]:not(:has([data-option-input]:checked))');
        if (!variant && unchosen) {
          var optionName = unchosen.querySelector('.variant-picker__name').textContent.trim();
          var template = atc.dataset.textChoose;
          atc.disabled = true;
          atc.textContent = template.replace('[OPTION]', template.indexOf('[OPTION]') === 0 ? optionName : optionName.toLowerCase());
        } else if (!variant) {
          atc.disabled = true;
          atc.textContent = atc.dataset.textUnavailable;
        } else if (inWorkshop) {
          atc.disabled = true;
          atc.textContent = atc.dataset.textWorkshop;
        } else if (!variant.available) {
          atc.disabled = true;
          atc.textContent = atc.dataset.textSoldout;
        } else {
          atc.disabled = false;
          atc.textContent = atc.dataset.textAdd;
        }
        if (adding) {
          atc.disabled = true;
          atc.textContent = atc.dataset.textAdding;
        }
        var notifyEl = root.querySelector('[data-notify]');
        // After a newsletter post the form is replaced by its confirmation (no
        // variant field); keep that visible whatever variant Shopify returns to.
        if (notifyEl && notifyEl.querySelector('[data-notify-variant]')) notifyEl.hidden = !variant || (variant.available && !inWorkshop);
        else if (notifyEl) notifyEl.hidden = false;
        var stickyBtn = section.querySelector('[data-sticky-add]');
        if (stickyBtn) {
          stickyBtn.disabled = atc.disabled;
          stickyBtn.textContent = atc.textContent;
        }
        // Buy-now skips the cart entirely, so it has to follow the same
        // rule as add-to-cart or a size we don't produce stays purchasable.
        var buyNow = root.querySelector('[data-buy-now]');
        if (buyNow) buyNow.disabled = atc.disabled;
      }

      function updateMedia(variant, values) {
        var gallery = root.querySelector('[data-gallery]');
        if (!gallery) return;
        var thumbs = Array.from(gallery.querySelectorAll('.gallery__thumb'));
        var value = String(values[galleryOptionIndex] || '').toLowerCase().trim();
        var finish = String(values[hardwareOptionIndex] || '').toLowerCase().trim();
        // Translated fitting names (Silber, Argent, Plata …) map to the media filename tokens.
        finish = { silber: 'silver', argent: 'silver', argento: 'silver', plata: 'silver', prateado: 'silver', or: 'gold', oro: 'gold', dourado: 'gold' }[finish] || finish;
        var variantMediaId = variant && variant.featured_media ? String(variant.featured_media.id) : null;
        function filename(thumb) {
          var img = thumb.querySelector('img');
          return img ? (img.getAttribute('src') || '').split('?')[0].toLowerCase() : '';
        }
        function finishOf(thumb) {
          var file = filename(thumb);
          return file.includes('__gold__') ? 'gold' : file.includes('__silver__') ? 'silver' : '';
        }
        function matches(thumb) {
          if (thumb.dataset.optionValue && thumb.dataset.optionValue !== value) return false;
          var mediaFinish = finishOf(thumb);
          return !finish || !mediaFinish || mediaFinish === finish;
        }
        var matching = thumbs.filter(matches);
        var colourViews = matching.filter(function (thumb) { return !!thumb.dataset.optionValue; });
        var assigned = matching.find(function (thumb) { return thumb.dataset.thumbId === variantMediaId; });
        var lead = assigned;
        if (!lead || /__detail-square(?:__|\.)/.test(filename(lead)) || (!lead.dataset.optionValue && colourViews.length)) {
          lead = colourViews.find(function (thumb) { return !/__detail-square(?:__|\.)/.test(filename(thumb)); }) || lead || colourViews[0];
        }
        lead = lead || matching[0];
        // Finish not chosen yet: the gold and silver recolours of one colour
        // look identical at thumb size, so show only the lead's finish.
        var leadFinish = !finish && lead ? finishOf(lead) : '';
        if (leadFinish) {
          matching = matching.filter(function (thumb) { var f = finishOf(thumb); return !f || f === leadFinish; });
        }
        if (lead && lead.dataset.optionValue) {
          matching = matching.filter(function (thumb) { return thumb === lead || !thumb.hasAttribute('data-base-shot'); });
        }
        var ordered = lead ? [lead].concat(colourViews.filter(function (thumb) { return thumb !== lead; })) : [];
        ordered = ordered.concat(matching.filter(function (thumb) { return !ordered.includes(thumb); }));
        thumbs.forEach(function (thumb) {
          thumb.hidden = !matching.includes(thumb);
          thumb.classList.toggle('gallery__thumb--lead', thumb === lead);
          if (!thumb.hidden) {
            var img = thumb.querySelector('img');
            if (img) img.loading = 'eager';
          }
        });
        var rail = gallery.querySelector('.gallery__thumbs');
        ordered.forEach(function (thumb) { rail.appendChild(thumb); });
        var selection = value + '|' + finish;
        var current = thumbs.find(function (thumb) { return thumb.classList.contains('is-current') && !thumb.hidden; });
        if (lead && (gallery.dataset.selection !== selection || !current)) {
          setCurrentMedia(gallery, lead.dataset.thumbId);
          rail.scrollLeft = 0;
        }
        gallery.dataset.selection = selection;
      }

      function setCurrentMedia(gallery, mediaId) {
        var slides = Array.from(gallery.querySelectorAll('.gallery__slide'));
        if (!slides.some(function (slide) { return slide.dataset.mediaId === mediaId; })) return;
        var recoloured = false;
        slides.forEach(function (slide) {
          var current = slide.dataset.mediaId === mediaId;
          slide.classList.toggle('is-current', current);
          slide.inert = !current;
          slide.setAttribute('aria-hidden', String(!current));
          if (current) {
            recoloured = !!slide.dataset.optionValue;
            var img = slide.querySelector('img');
            if (img) img.loading = 'eager';
          } else {
            slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
        });
        gallery.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
          var current = thumb.dataset.thumbId === mediaId;
          thumb.classList.toggle('is-current', current);
          thumb.setAttribute('aria-current', String(current));
        });
        var note = gallery.querySelector('[data-gallery-note]');
        if (note) note.hidden = !recoloured;
      }

      function updateAvailabilityMarks(values) {
        if (!picker) return;
        picker.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var index = parseInt(fieldset.dataset.optionIndex, 10);
          fieldset.querySelectorAll('[data-option-input]').forEach(function (input) {
            var test = values.slice();
            test[index] = input.value;
            // An option not chosen yet (hardware starts empty) matches any value.
            var match = variants.find(function (variant) {
              return variant.options.every(function (opt, i) {
                return test[i] == null || opt === test[i];
              });
            });
            // Strike only combinations that don't exist. Sold-out-but-real
            // variants stay full-color and selectable — availability is
            // communicated at the add-to-cart button, not by ghosting the
            // whole palette (at launch everything is made-to-order anyway).
            input.classList.toggle('is-unavailable', !match);
          });
        });
      }

      function updateSelectedLabels() {
        if (!picker) return;
        picker.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('[data-option-input]:checked');
          var label = fieldset.querySelector('[data-selected-value]');
          if (checked && label) label.textContent = checked.value;
        });
      }

      function onOptionChange() {
        var values = selectedOptions();
        var variant = findVariant(values);
        if (idInput) idInput.disabled = !variant;
        if (variant && idInput) {
          idInput.value = variant.id;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          url.searchParams.delete('farbe');
          window.history.replaceState({}, '', url.toString());
        }
        var notifyVariant = root.querySelector('[data-notify-variant]');
        if (notifyVariant && variant && notifyVariant.value !== String(variant.id)) {
          notifyVariant.value = variant.id;
          // A new variant is a new request: bring the form back after a success.
          notifyVariant.form.querySelector('.product__notify-row').hidden = false;
          notifyVariant.form.querySelector('[data-notify-success]').hidden = true;
          notifyVariant.form.querySelector('[data-notify-error]').hidden = true;
          notifyVariant.form.querySelector('[type="submit"]').disabled = false;
        }
        updateSelectedLabels();
        updatePrice(variant);
        updateButton(variant);
        updateMedia(variant, values);
        updateAvailabilityMarks(values);
      }

      var notifyForm = root.querySelector('[data-notify-form]');
      if (notifyForm && notifyForm.querySelector('[data-notify-variant]')) {
        notifyForm.addEventListener('submit', function (event) {
          var data = new FormData(notifyForm);
          // text/plain keeps it a simple CORS request, so keepalive lets it
          // finish even when the native newsletter submit reloads the page.
          var restock = fetch(notifyForm.dataset.endpoint, {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
              email: data.get('contact[email]'),
              variant_id: data.get('variant_id'),
              product_handle: notifyForm.dataset.handle,
              locale: notifyForm.dataset.locale,
              company: data.get('company')
            })
          });
          if (data.get('newsletter')) return;
          event.preventDefault();
          var btn = notifyForm.querySelector('[type="submit"]');
          var errorEl = notifyForm.querySelector('[data-notify-error]');
          btn.disabled = true;
          errorEl.hidden = true;
          restock.then(function (res) {
            if (!res.ok) throw new Error(res.status);
            notifyForm.querySelector('.product__notify-row').hidden = true;
            var box = notifyForm.querySelector('.product__notify-newsletter');
            if (box) box.hidden = true;
            notifyForm.querySelector('[data-notify-success]').hidden = false;
          }).catch(function () {
            errorEl.hidden = false;
            btn.disabled = false;
          });
        });
      }

      if (picker) {
        picker.addEventListener('change', function (event) {
          if (event.target.matches('[data-option-input]')) {
            onOptionChange();
          }
        });

        // Colour deep-link: product cards and the Farben page link to
        // ?farbe=<handleized value>, so a visitor who picks a colour while
        // browsing lands on the product with that colour already selected.
        var wanted = new URLSearchParams(window.location.search).get('farbe');
        if (wanted && !new URLSearchParams(window.location.search).get('variant')) {
          var slug = function (value) {
            return String(value)
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
          };
          var target = slug(wanted);
          var match = Array.prototype.find.call(
            picker.querySelectorAll('[data-option-index="' + galleryOptionIndex + '"] [data-option-input]'),
            function (input) {
              return slug(input.value) === target;
            }
          );
          if (match && !match.checked) match.checked = true;
        }

        // Don't open on a value the workshop isn't making. Liquid picks the
        // first *available* variant, and with everything at zero stock that
        // is simply the first one — which lands the visitor on a disabled
        // button before they have chosen anything. Only nudges the untouched
        // default: an explicit ?variant= or ?farbe= link is left alone.
        var deepLinked = new URLSearchParams(window.location.search);
        if (!deepLinked.get('variant') && !deepLinked.get('farbe')) {
          picker.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
            var checked = fieldset.querySelector('[data-option-input]:checked');
            // A marked (not produced) default moves to the first offered
            // value; hardware is left unchosen on purpose.
            if (checked && !checked.hasAttribute('data-workshop')) return;
            if (!checked && fieldset.hasAttribute('data-require-choice')) return;
            var alternative = fieldset.querySelector('[data-option-input]:not([data-workshop])');
            if (alternative) alternative.checked = true;
          });
        }

        onOptionChange();
      }

      var gallery = root.querySelector('[data-gallery]');
      if (gallery) {
        gallery.addEventListener('click', function (event) {
          var thumb = event.target.closest('.gallery__thumb');
          if (thumb) setCurrentMedia(gallery, thumb.dataset.thumbId);
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (adding || (atc && atc.disabled) || !form.reportValidity()) return;
          adding = true;
          if (errorEl) errorEl.hidden = true;
          // event.submitter tells us which button posted the form, so
          // "Jetzt kaufen" can skip the drawer and go to checkout.
          var goToCheckout = !!(event.submitter && event.submitter.hasAttribute('data-buy-now'));
          var stickyMirror = section.querySelector('[data-sticky-add]');
          if (atc) {
            // Fix the pill width so the label swap never reflows the row.
            atc.style.minWidth = atc.offsetWidth + 'px';
            atc.disabled = true;
            atc.setAttribute('aria-busy', 'true');
            atc.textContent = atc.dataset.textAdding || atc.textContent;
            if (stickyMirror) {
              stickyMirror.disabled = true;
              stickyMirror.textContent = atc.textContent;
            }
          }
          var buyNow = root.querySelector('[data-buy-now]');
          if (buyNow) buyNow.disabled = true;
          confirmDuplicate(findVariant(selectedOptions()))
            .then(function (confirmed) {
              if (!confirmed) throw CANCELLED;
              return fetch(cartRoot + 'cart/add.js', {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: new FormData(form)
              });
            })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw new Error(data.description || data.message || root.dataset.addError);
                return data;
              });
            })
            .then(function () {
              if (goToCheckout) {
                window.location.href = root.dataset.checkoutUrl || '/checkout';
                return;
              }
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
              // A quiet beat of confirmation before the drawer takes over;
              // one calm pulse on the header cart count (skipped by CSS
              // under prefers-reduced-motion).
              if (atc) atc.textContent = atc.dataset.textAdded || atc.dataset.textAdd;
              if (stickyMirror && atc) stickyMirror.textContent = atc.textContent;
              var count = document.querySelector('[data-cart-count]');
              if (count) {
                count.classList.remove('is-pulsing');
                void count.offsetWidth;
                count.classList.add('is-pulsing');
              }
              window.setTimeout(function () {
                onOptionChange();
              }, 1200);
            })
            .catch(function (error) {
              if (error === CANCELLED) return;
              if (errorEl) {
                errorEl.textContent = error.message === 'Failed to fetch' || error instanceof TypeError || error instanceof SyntaxError
                  ? root.dataset.addError : error.message;
                errorEl.hidden = false;
              }
              onOptionChange();
            })
            .finally(function () {
              adding = false;
              if (atc) atc.removeAttribute('aria-busy');
              updateButton(findVariant(selectedOptions()));
            });
        });

        var sticky = section.querySelector('[data-sticky-atc]');
        var stickyAdd = section.querySelector('[data-sticky-add]');
        if (sticky && 'IntersectionObserver' in window) {
          var stickyObserver = new IntersectionObserver(
            function (entries) {
              var entry = entries[0];
              // Show only after the buy row scrolls up out of view — not
              // while it is still below the fold on page load.
              var passed = entry.boundingClientRect.top < 0;
              sticky.classList.toggle('is-visible', !entry.isIntersecting && passed);
            },
            { threshold: 0 }
          );
          stickyObserver.observe(form);
        }
        if (stickyAdd) {
          stickyAdd.addEventListener('click', function () {
            if (form.requestSubmit) {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { cancelable: true }));
            }
          });
        }
      }

      var dialog = section.querySelector('[data-size-guide]');
      if (dialog) {
        root.addEventListener('click', function (event) {
          if (event.target.closest('[data-size-guide-open]')) dialog.showModal();
        });
        dialog.addEventListener('click', function (event) {
          if (event.target.closest('[data-size-guide-close]') || event.target === dialog) dialog.close();
        });
      }
      if (duplicateCheck) {
        // A backdrop click counts as "don't add", like Escape.
        duplicateCheck.addEventListener('click', function (event) {
          if (event.target === duplicateCheck) duplicateCheck.close();
        });
      }
    }

    function run() {
      document.querySelectorAll('[data-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-popup"]) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-search-popup]');
    if (!popup || popup.dataset.searchReady === 'true') return;
    popup.dataset.searchReady = 'true';

    var input = popup.querySelector('[data-search-input]');
    var results = popup.querySelector('[data-search-results]');
    var section = popup.closest('.shopify-section');
    var sectionId = section ? section.id.replace('shopify-section-', '') : 'search-popup';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var errorEl = popup.querySelector('[data-search-error]');
    var fallback = popup.querySelector('[data-search-fallback]');
    var closeTimer;
    var debounce;
    var lastTerm = '';
    var lastFocus = null;

    function panel() {
      return popup.querySelector('.search-popup__panel') || popup;
    }

    function open(trigger) {
      window.clearTimeout(closeTimer);
      lastFocus = trigger || document.activeElement;
      popup.hidden = false;
      // Force a reflow so the enter transition runs without relying on rAF.
      void popup.offsetWidth;
      popup.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (input) {
        input.focus();
        input.select();
      }
    }

    function close() {
      popup.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(function () {
        popup.hidden = true;
        if (window.VamoyaFocus) window.VamoyaFocus.focusQuietly(lastFocus);
        else if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        lastFocus = null;
      }, 240); // matches --dur-base; keep in sync with the CSS transition
    }

    function fetchResults(term) {
      errorEl.hidden = true;
      results.setAttribute('data-state', 'loading');
      var url =
        root +
        'search/suggest?q=' +
        encodeURIComponent(term) +
        '&section_id=' +
        encodeURIComponent(sectionId) +
        '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('search');
          return response.text();
        })
        .then(function (html) {
          // Ignore stale responses if the query changed while in flight.
          if (term !== lastTerm) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-search-results]');
          if (!fresh) throw new Error('search');
          results.innerHTML = fresh.innerHTML;
          results.removeAttribute('data-state');
        })
        .catch(function () {
          if (term !== lastTerm) return;
          results.innerHTML = '';
          fallback.href = root + 'search?q=' + encodeURIComponent(term) + '&options[prefix]=last';
          errorEl.hidden = false;
          results.removeAttribute('data-state');
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        lastTerm = term;
        errorEl.hidden = true;
        window.clearTimeout(debounce);
        if (term.length < 2) {
          results.innerHTML = '';
          results.removeAttribute('data-state');
          return;
        }
        debounce = window.setTimeout(function () {
          fetchResults(term);
        }, 220);
      });
    }

    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-search-open]');
      if (openBtn) {
        event.preventDefault();
        open(openBtn);
        return;
      }
      if (event.target.closest('[data-search-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (window.VamoyaFocus) window.VamoyaFocus.trap(event, panel());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
